var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import FlyoutControlled from "./FlyoutControlled.js";
var FlyoutUncontrolled = function (props, ref) {
    var defaultActive = props.defaultActive, onClose = props.onClose, onOpen = props.onOpen;
    var _a = React.useState(defaultActive || false), active = _a[0], setActive = _a[1];
    var handleClose = function () {
        setActive(false);
        if (onClose)
            onClose();
    };
    var handleOpen = function () {
        setActive(true);
        if (onOpen)
            onOpen();
    };
    return (React.createElement(FlyoutControlled, __assign({}, props, { ref: ref, defaultActive: undefined, active: active, onClose: handleClose, onOpen: handleOpen })));
};
export default React.forwardRef(FlyoutUncontrolled);
